export default "__VITE_ASSET__7SwFJSfX__"